import { ReactNode } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { dataGridStyles } from "../theme/appTheme";

type DataGridViewportProps = {
  children: ReactNode;
  height: number | string;
  minWidth?: number;
  sx?: SxProps<Theme>;
};

const DataGridViewport = ({ children, height, minWidth: _minWidth, sx }: DataGridViewportProps) => (
  <Box
    sx={{
      height,
      maxHeight: "calc(100vh - 260px)",
      minHeight: 320,
      width: "100%",
      minWidth: 0,
      overflowX: "hidden",
      overflowY: "hidden",
      overscrollBehavior: "contain",
      "& .MuiDataGrid-root": {
        width: "100%",
        minWidth: 0,
        ...dataGridStyles.root,
      },
      "& .MuiDataGrid-columnHeaders": {
        ...dataGridStyles.columnHeaders,
      },
      "& .MuiDataGrid-columnHeader": {
        ...dataGridStyles.columnHeader,
      },
      "& .MuiDataGrid-columnHeaderTitle": {
        ...dataGridStyles.columnHeaderTitle,
      },
      "& .MuiDataGrid-iconSeparator": {
        ...dataGridStyles.iconSeparator,
      },
      "& .MuiDataGrid-sortIcon": {
        ...dataGridStyles.sortIcon,
      },
      "& .MuiDataGrid-menuIconButton": {
        ...dataGridStyles.menuIconButton,
      },
      "& .MuiDataGrid-virtualScroller": {
        overflowX: "auto",
      },
      "& .MuiDataGrid-main": {
        minWidth: 0,
      },
      ...sx,
    }}
  >
    <Box sx={{ height: "100%", width: "100%", minWidth: 0 }}>
      {children}
    </Box>
  </Box>
);

export default DataGridViewport;
